module.exports = __webpack_public_path__ + "img/29.10759d9f.png";